import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import AuthUserContainer from '../../../../containers/AuthUser';
import Transition from '../../../../components/dialogs/Transition';
import FormComponent from '../../../../components/FormComponent';
import { dialogStyles } from './dialogStyles';

const styles = () => {
	return {
		...dialogStyles,
	};
};

class MobileDeliveryScanSaveConfirmationDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	handleCloseWithoutSaving = () => {
		this.props.onCloseWithoutSaving();
	};

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { open, classes } = this.props;
		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'lg'}
				classes={{ scrollPaper: classes.dialogRoot, paper: classes.dialogPaper }}
			>
				<DialogContent style={{ position: 'relative' }}>
					<div className={classes.dialogTitle}>
						<div>You hit close without saving? Are you sure? </div>
					</div>
				</DialogContent>

				<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
					<div style={{ display: 'flex', width: '100%', padding: '0 2vw' }}>
						<Button
							variant="contained"
							color="secondary"
							aria-label="submitConsigneeDelay"
							className={classes.dialogSubmitButton}
							onClick={this.props.onCloseAllDialogs}
						>
							Yes, close without saving
						</Button>

						<Button
							variant="outlined"
							className={classes.dialogCloseButton}
							onClick={this.props.onClose}
						>
							Cancel
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

MobileDeliveryScanSaveConfirmationDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	onCloseAllDialogs: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer])(
	MobileDeliveryScanSaveConfirmationDialog
);
